export default __webpack_public_path__ + "static/media/6.4d9b3580.jpg";